export interface IFontStyle {
    fontFamily?: string;
    fontSize?: number;
    fontStyle?: 'normal' | 'italic' | 'oblique';
    fontWeight?: 'normal' | 'bold';
}

export interface IColorStyle {
    color?: string;
}

export interface IBorderStyle {
    borderWidth?: number;
    borderColor?: string;
    borderStyle?: 'solid' | 'dashed' | 'dotted';
}

export interface IBackgroundStyle {
    backgroundColor?: string;
    opacity?: number;
}

export class Style implements IFontStyle, IColorStyle, IBorderStyle, IBackgroundStyle {

    // 字体属性
    fontFamily?: string;
    fontSize?: number;
    fontStyle?: 'normal' | 'italic' | 'oblique';
    fontWeight?: 'normal' | 'bold';

    // 颜色属性
    color?: string;

    // 边框属性
    borderWidth?: number;
    borderColor?: string;
    borderStyle?: 'solid' | 'dashed' | 'dotted';

    // 背景属性
    backgroundColor?: string;
}